import React from 'react';
import { ArrowRight } from 'lucide-react';

interface NextButtonProps {
  isLoading?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  type?: 'button' | 'submit';
  children?: React.ReactNode;
  variant?: 'primary' | 'secondary';
  className?: string;
}

export const NextButton: React.FC<NextButtonProps> = ({
  isLoading = false,
  disabled = false,
  onClick,
  type = 'submit',
  children,
  variant = 'primary',
  className = '',
}) => {
  const variantStyles = {
    primary:
      'h-12 px-8 bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 text-white shadow-lg hover:shadow-xl text-lg',
    secondary:
      'h-12 px-6 bg-white dark:bg-white/5 hover:bg-gray-50 dark:hover:bg-white/10 text-gray-700 dark:text-gray-300 border-2 border-gray-300 dark:border-white/15 hover:border-gray-400 dark:hover:border-white/25',
  };

  return (
    <div className="flex justify-end pt-4 border-t dark:border-white/10">
      <button
        type={type}
        disabled={disabled || isLoading}
        onClick={onClick}
        className={`${variantStyles[variant]} font-semibold transition-all inline-flex items-center gap-2 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      >
        {isLoading ? (
          <>
            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-current" />
            {children || 'Loading...'}
          </>
        ) : (
          <>
            {children || 'Next'}
            {variant === 'primary' && <ArrowRight className="w-5 h-5" />}
          </>
        )}
      </button>
    </div>
  );
};
